import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import Link from 'gatsby-link'
import ArrowDown from 'react-icons/lib/md/arrow-drop-down'
import cx from 'classnames'

const styles = (theme) => ({
  navLink: {
    fontSize: '0.8em',
    fontWeight: 400,
    position: 'relative',
    display: 'inline-block',
    color: '#fff',
    transition: 'color 0.5s',
    padding: '2px 6px',
    '&:hover': {
      color: theme.palette.link.hoveringOnSecondary,
    },
  },
  navLinkOverAccent: {
    position: 'relative',
    display: 'inline-block',
    color: '#fff',
    transition: 'color 0.5s',
    '&:hover': {
      color: theme.palette.link.hoveringOnSecondary,
    },
  },
  dropdownNavLink: {
    position: 'relative',
    display: 'inline-block',
    color: '#fff',
    transition: 'color 0.5s',
    padding: '2px 5px 2px 15px',
    '&:hover': {
      '& > div': {
        // .dropdownInnerContainer
        display: 'block',
      },
    },
  },
  dropdownContent: {
    display: 'none',
    position: 'absolute',
    top: 31,
    left: -2,
    width: 300,
    background: theme.palette.background.light,
    border: '1px solid #ddd',
    zIndex: 1,
  },
  dropdownItem: {
    fontSize: '0.95em',
    color: '#fff',
    padding: 8,
    textDecoration: 'none',
    display: 'block',
    transition: 'background 0.6s, color 0.6s',
    background: theme.palette.primary.main,
    '&:hover': {
      opacity: 1,
      color: theme.palette.link.nav,
      background: '#fff',
      '& > span.label': {
        color: theme.palette.link.main,
      },
    },
  },
  attentionStyle: {
    cursor: 'default',
    fontWeight: 500,
    border: '1px solid #7ca7b1',
    backgroundColor: theme.palette.primary.mainDarker,
  },
  arrowDown: {
    transform: 'scale(1.3)',
    position: 'relative',
    bottom: 1,
    fontSize: '1.8em',
  },
})

// For large screens only
const SecondaryLargeNavItem = ({
  classes,
  theme,
  to,
  label,
  children,
  attention,
}) => {
  let frontLabel = null
  const linkProps = {}

  if (children) {
    if (to) {
      frontLabel = (
        <Typography
          component={Link}
          to={to}
          style={{ color: '#fff' }}
          activeStyle={{ color: theme.palette.primary.lighter }}
        >
          {label}
          <ArrowDown className={classes.arrowDown} />
        </Typography>
      )
    } else {
      frontLabel = (
        <span className={classes.navLinkOverAccent}>
          {label}
          <ArrowDown className={classes.arrowDown} />
        </span>
      )
    }
  } else {
    frontLabel = (
      <Typography
        component={Link}
        to={to}
        activeStyle={{ color: theme.palette.primary.lighter }}
        className={cx(classes.navLink, {
          [classes.attentionStyle]: attention === true,
        })}
      >
        {label}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </Typography>
    )
  }

  return children ? (
    <Typography
      component="div"
      className={cx(classes.dropdownNavLink, {
        [classes.attentionStyle]: attention === true,
      })}
    >
      {frontLabel}
      {children && (
        <div className={classes.dropdownContent}>
          {children.map((props) => {
            const linkProps = {}
            if (props.outbound) {
              linkProps.component = 'a'
              linkProps.href = props.to
            } else {
              linkProps.component = Link
              linkProps.to = props.to
            }
            return (
              <Typography
                key={props.to}
                className={classes.dropdownItem}
                {...linkProps}
                noWrap
              >
                {props.sublabel ? (
                  <Fragment>
                    <span className="label">{props.label}</span>&nbsp;{' '}
                    <span className="sublabel">({props.sublabel})</span>
                  </Fragment>
                ) : (
                  props.label
                )}
              </Typography>
            )
          })}
        </div>
      )}
    </Typography>
  ) : (
    frontLabel
  )
}

SecondaryLargeNavItem.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  to: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.array,
  attention: PropTypes.bool,
}

export default withStyles(styles, { withTheme: true })(SecondaryLargeNavItem)



// WEBPACK FOOTER //
// ./src/components/Navigation/SecondaryLargeNavItem.js